module.exports = __webpack_public_path__ + "static/media/james1.764c8e16.mp3";